import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import {
  CreateTablePayload,
  ITable,
  Navigation,
  PagesAndDashboard,
  UpdateTablePayload,
  UpdateTableResponse,
  ValidateTablePayload,
} from '../_models/table.models';
import { ApplicationActionTypes } from './application.actions';

/**
 * Navigation action types
 */
export enum TableActionTypes {
  LOAD_NAVIGATION = '[Navigation] Load Navigation',
  LOAD_NAVIGATION_SUCCESS = '[Navigation] Load Navigation Success',
  LOAD_NAVIGATION_FAILED = '[Navigation] Load Navigation Failed',
  TOGGLE_NAVIGATION = '[Navigation] Toggle Navigation',
  UPDATE_TABLE = '[Navigation] Update Table',
  UPDATE_TABLE_SUCCESS = '[Navigation] Update Table Success',
  UPDATE_TABLE_FAILED = '[Navigation] Update Table Failed',
  DELETE_TABLE = '[Navigation] Delete Table',
  DELETE_TABLE_SUCCESS = '[Navigation] Delete Table Success',
  DELETE_TABLE_FAILED = '[Navigation] Delete Table Failed',
  CREATE_TABLE = '[Navigation] Create Table',
  CREATE_TABLE_SUCCESS = '[Navigation] Create Table Success',
  CREATE_TABLE_FAILED = '[Navigation] Create Table Failed',
  ARRANGE_TABLE = '[Navigation] Arrange Table',
  ARRANGE_TABLE_SUCCESS = '[Navigation] Arrange Table Success',
  ARRANGE_TABLE_FAILED = '[Navigation] Arrange Table Failed',
  VALIDATE_TABLE_NAME = '[Table] Validate Table Name',
  VALIDATE_TABLE_NAME_SUCCESS = '[Table] Validate Table Name Success',
  VALIDATE_TABLE_NAME_FAILED = '[Table] Validate Table Name Failed',
  LOAD_TABLES = '[Table] Load Tables',
  LOAD_TABLES_SUCCESS = '[Table] Load Tables Success',
  LOAD_TABLES_FAILED = '[Table] Load Tables Failed',
  LOAD_ALL_TABLES = '[Table] Load All Tables',
  LOAD_ALL_TABLES_SUCCESS = '[Table] Load All Tables Success',
  LOAD_ALL_TABLES_FAILED = '[Table] Load All Tables Failed',
  LOAD_PAGES_DASHBOARD = '[Table] Load PagesAndDashboard',
  LOAD_PAGES_DASHBOARD_SUCCESS = '[Table] Load PagesAndDashboard Success',
  LOAD_PAGES_DASHBOARD_Failed = '[Table] Load PagesAndDashboard Failed',
  UPDATE_PAGES_DASHBOARD = '[Table] Update PagesAndDashboard',
  UPDATE_PAGES_DASHBOARD_SUCCESS = '[Table] Update PagesAndDashboard Success',
  UPDATE_PAGES_DASHBOARD_FAILED = '[Table] Update PagesAndDashboard Failed',
  TABLE_HAS_DATA = '[Table] Table Has Data',
  TABLE_HAS_DATA_SUCCESS = '[Table] Table Has Data Success',
  TABLE_HAS_DATA_FAILED = '[Table] Table Has Data Failed',
  RESET = '[Navigation] RESET',
}

/**
 * Operations
 */
export class LoadNavigation implements Action {
  readonly type = TableActionTypes.LOAD_NAVIGATION;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadNavigationSuccess implements Action {
  readonly type = TableActionTypes.LOAD_NAVIGATION_SUCCESS;

  constructor(
    public applicationId: string,
    public payload: Array<Navigation>
  ) {}
}

export class LoadNavigationFailed implements Action {
  readonly type = TableActionTypes.LOAD_NAVIGATION_FAILED;

  constructor(public payload: Error) {}
}

export class ToggleNavigation implements Action {
  readonly type = TableActionTypes.TOGGLE_NAVIGATION;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string,public order:number,public isExpended:boolean) {}
}

export class UpdatePagesAndDashboard implements Action {
  readonly type = TableActionTypes.UPDATE_PAGES_DASHBOARD;
  constructor(public payload: any) {}
}
export class UpdatePagesAndDashboardSuccess implements Action {
  readonly type = TableActionTypes.UPDATE_PAGES_DASHBOARD_SUCCESS;
}

export class UpdatePagesAndDashboardFailed implements Action {
  readonly type = TableActionTypes.UPDATE_PAGES_DASHBOARD_FAILED;
  constructor(public payload: Error) {}
}

export class LoadPageAndDashboard implements Action {
  readonly type = TableActionTypes.LOAD_PAGES_DASHBOARD;
  constructor(public tableId: string) {}
}
export class LoadPageAndDashboardSuccess implements Action {
  readonly type = TableActionTypes.LOAD_PAGES_DASHBOARD_SUCCESS;
  constructor(public tableId: string, public payload: Array<any>) {}
}

export class LoadPageAndDashboardFailed implements Action {
  readonly type = TableActionTypes.LOAD_PAGES_DASHBOARD_Failed;
  constructor(public payload: Error) {}
}

export class UpdateTable extends Reference implements Action {
  readonly type = TableActionTypes.UPDATE_TABLE;

  constructor(public payload: UpdateTablePayload) {
    super();
  }
}

export class UpdateTableSuccess extends Reference implements Action {
  readonly type = TableActionTypes.UPDATE_TABLE_SUCCESS;

  constructor(
    public applicationId: string,
    public tableId: string,
    public payload: UpdateTableResponse
  ) {
    super();
  }
}

export class UpdateTableFailed extends Reference implements Action {
  readonly type = TableActionTypes.UPDATE_TABLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteTable extends Reference implements Action {
  readonly type = TableActionTypes.DELETE_TABLE;

  constructor(public applicationId: string, public tableId: string) {
    super();
  }
}

export class DeleteTableSuccess extends Reference implements Action {
  readonly type = TableActionTypes.DELETE_TABLE_SUCCESS;

  constructor(public applicationId: string, public tableId: string) {
    super();
  }
}

export class DeleteTableFailed extends Reference implements Action {
  readonly type = TableActionTypes.DELETE_TABLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ArrangeTable extends Reference implements Action {
  readonly type = TableActionTypes.ARRANGE_TABLE;

  constructor(public payload: any) {
    super();
  }
}

export class ArrangeTableSuccess extends Reference implements Action {
  readonly type = TableActionTypes.ARRANGE_TABLE_SUCCESS;

  constructor(public response: any) {
    super();
  }
}

export class ArrangeTableFailed extends Reference implements Action {
  readonly type = TableActionTypes.ARRANGE_TABLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateTable extends Reference implements Action {
  readonly type = TableActionTypes.CREATE_TABLE;

  constructor(public payload: CreateTablePayload) {
    super();
  }
}

export class CreateTableSuccess extends Reference implements Action {
  readonly type = TableActionTypes.CREATE_TABLE_SUCCESS;

  constructor(
    public applicationId: string,
    public payload: UpdateTableResponse
  ) {
    super();
  }
}

export class CreateTableFailed extends Reference implements Action {
  readonly type = TableActionTypes.CREATE_TABLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ValidateTableName implements Action {
  readonly type = TableActionTypes.VALIDATE_TABLE_NAME;

  constructor(public applicationId: string, public name: string) {}
}

export class ValidateTableNameSuccess implements Action {
  readonly type = TableActionTypes.VALIDATE_TABLE_NAME_SUCCESS;

  constructor(
    public applicationId: string,
    public payload: ValidateTablePayload
  ) {}
}

export class ValidateTableNameFailed implements Action {
  readonly type = TableActionTypes.VALIDATE_TABLE_NAME_FAILED;

  constructor(public payload: Error) {}
}

export class LoadTables implements Action {
  readonly type = TableActionTypes.LOAD_TABLES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadTablesSuccess implements Action {
  readonly type = TableActionTypes.LOAD_TABLES_SUCCESS;

  constructor(public applicationId: string, public payload: Array<ITable>) {}
}

export class LoadTablesFailed implements Action {
  readonly type = TableActionTypes.LOAD_TABLES_FAILED;

  constructor(public payload: Error, public applicationId: string) {}
}
export class LoadAllTables implements Action {
  readonly type = TableActionTypes.LOAD_ALL_TABLES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadAllTablesSuccess implements Action {
  readonly type = TableActionTypes.LOAD_ALL_TABLES_SUCCESS;

  constructor(public applicationId: string, public payload: Array<ITable>) {}
}

export class LoadAllTablesFailed implements Action {
  readonly type = TableActionTypes.LOAD_ALL_TABLES_FAILED;

  constructor(public payload: Error, public applicationId: string = '') {}
}

export class CheckTableHasData implements Action {
  readonly type = TableActionTypes.TABLE_HAS_DATA;

  constructor(public tableId: string) {}
}

export class CheckTableHasDataSuccess implements Action {
  readonly type = TableActionTypes.TABLE_HAS_DATA_SUCCESS;

  constructor(public tableId: string, public hasData: boolean) {}
}

export class CheckTableHasDataFailed implements Action {
  readonly type = TableActionTypes.TABLE_HAS_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class Reset implements Action {
  readonly type = TableActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadNavigation
  | LoadNavigationSuccess
  | LoadNavigationFailed
  | ToggleNavigation
  | UpdateTable
  | UpdateTableSuccess
  | UpdateTableFailed
  | DeleteTable
  | DeleteTableSuccess
  | DeleteTableFailed
  | CreateTable
  | CreateTableSuccess
  | CreateTableFailed
  | ValidateTableName
  | ValidateTableNameSuccess
  | ValidateTableNameFailed
  | ArrangeTable
  | ArrangeTableSuccess
  | ArrangeTableFailed
  | LoadTables
  | LoadTablesSuccess
  | LoadTablesFailed
  | LoadAllTables
  | LoadAllTablesSuccess
  | LoadAllTablesFailed
  | LoadPageAndDashboard
  | LoadPageAndDashboardSuccess
  | LoadPageAndDashboardFailed
  | UpdatePagesAndDashboard
  | UpdatePagesAndDashboardSuccess
  | UpdatePagesAndDashboardFailed
  | CheckTableHasData
  | CheckTableHasDataSuccess
  | CheckTableHasDataFailed
  | Reset;
